import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DEFAULT_BRAND as PLATFORM_DEFAULT_BRAND } from '@/theme/brandDefaults';

export interface BrandState {
  primaryColor: string;
  accentColor: string;
  successColor: string;
  /** Dark canvas base (system-layer brand config; not editable in any tenant UI). */
  baseColor: string;
  logoLightUrl: string;
  logoDarkUrl: string;
  faviconUrl: string;
}

/** Default (unbranded) RoofVox palette. Applied whenever there is no tenant brand loaded (signed out, or a
 *  tenant that hasn't customised its colors) so the previous tenant's brand never lingers on
 *  public/onboarding pages. Defined once in src/theme/brandDefaults.ts and re-exported here for existing importers. */
export const DEFAULT_BRAND = PLATFORM_DEFAULT_BRAND;

const initialState: BrandState = {
  primaryColor: DEFAULT_BRAND.primaryColor,
  accentColor: DEFAULT_BRAND.accentColor,
  successColor: DEFAULT_BRAND.successColor,
  baseColor: DEFAULT_BRAND.baseColor,
  logoLightUrl: '',
  logoDarkUrl: '',
  faviconUrl: '',
};

const brandSlice = createSlice({
  name: 'brand',
  initialState,
  reducers: {
    setBrand(state, action: PayloadAction<Partial<BrandState>>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { setBrand } = brandSlice.actions;
export default brandSlice.reducer;
